import { Grid } from '@mui/material';
import { observer } from 'mobx-react';
import TaskGradeEditPageStore from '../store/TaskGradeEditStore';
import React from 'react';

interface Props {
  pageStore: TaskGradeEditPageStore;
}

function TaskGradeEditBodyEmoticon(props: Props) {
  const { pageStore } = props;

  const handleClickEmoji = (emoji: any) => {
    pageStore.setEmoji(emoji);
    pageStore.setFomikValue({ emoticon: emoji });
  };

  const activeStyle = {
    background: '#ffffff',
    border: '1px solid #2281D0',
    width: '44px',
    height: '44px',
    cursor: 'pointer',
    borderRadius: '50%',
    paddingTop: '0px',
  };
  const inactiveStyle = {
    width: '44px',
    height: '44px',
    cursor: 'pointer',
    borderRadius: '50%',
    paddingTop: '9px',
  };

  return (
    <Grid
      container
      style={{
        background: '#F7F7F7',
        borderRadius: '10px',
        padding: '23px 38px',
        maxWidth: 580,
        margin: '10px auto 20px',
        fontSize: 30,
      }}
      justifyContent={'center'}
    >
      <Grid container justifyContent={'space-between'} alignItems={'center'}>
        <Grid onClick={() => handleClickEmoji('🙂')} style={pageStore.emoji === '🙂' ? activeStyle : inactiveStyle} textAlign='center'>
          🙂
        </Grid>
        <Grid onClick={() => handleClickEmoji('👍')} style={pageStore.emoji === '👍' ? activeStyle : inactiveStyle} textAlign='center'>
          👍
        </Grid>
        <Grid onClick={() => handleClickEmoji('⭕')} style={pageStore.emoji === '⭕' ? activeStyle : inactiveStyle} textAlign='center'>
          ⭕
        </Grid>
      </Grid>
      <Grid container justifyContent={'space-between'} style={{ marginTop: '24px' }}>
        <Grid onClick={() => handleClickEmoji('😐')} style={pageStore.emoji === '😐' ? activeStyle : inactiveStyle} textAlign='center'>
          😐
        </Grid>
        <Grid onClick={() => handleClickEmoji('🤔')} style={pageStore.emoji === '🤔' ? activeStyle : inactiveStyle} textAlign='center'>
          🤔
        </Grid>
      </Grid>
      <Grid container justifyContent={'space-between'} style={{ marginTop: '24px' }}>
        <Grid onClick={() => handleClickEmoji('😥')} style={pageStore.emoji === '😥' ? activeStyle : inactiveStyle} textAlign='center'>
          😥
        </Grid>
        <Grid onClick={() => handleClickEmoji('👎')} style={pageStore.emoji === '👎' ? activeStyle : inactiveStyle} textAlign='center'>
          👎
        </Grid>
        <Grid onClick={() => handleClickEmoji('❌')} style={pageStore.emoji === '❌' ? activeStyle : inactiveStyle} textAlign='center'>
          ❌
        </Grid>
      </Grid>
    </Grid>
  );
}

export default observer(TaskGradeEditBodyEmoticon);
